export default {
  'lv0': [{
    path: '/static/images/ceshiti/apple.png',
    spot: 'apple',
    voicepath:'/static/voice/vocabulary/1/apple.mp3'
  }, {
    path: '/static/images/ceshiti/bear.png',
    spot: 'bear',
    voicepath:'/static/voice/vocabulary/1/bear.mp3'
  }, {
    path: '/static/images/ceshiti/car.png',
    spot: 'car',
    voicepath:'/static/voice/vocabulary/1/Car.mp3'
  }, {
    path: '/static/images/ceshiti/duck.png',
    spot: 'duck',
    voicepath:'/static/voice/vocabulary/1/duck.mp3'
  }, {
    path: '/static/images/ceshiti/eggs.png',
    spot: 'eggs',
    voicepath:'/static/voice/vocabulary/1/eggs.mp3'
  }, {
    path: '/static/images/ceshiti/fish.png',
    spot: 'fish',
    voicepath:'/static/voice/vocabulary/1/fish.mp3'
  }, {
    path: '/static/images/ceshiti/gorilla.png',
    spot: 'gorilla',
    voicepath:'/static/voice/vocabulary/1/gorilla.mp3'
  }, {
    path: '/static/images/ceshiti/hands.png',
    spot: 'hands',
    voicepath:'/static/voice/vocabulary/1/hands.mp3'
  }, {
    path: '/static/images/ceshiti/ice creams.png',
    spot: 'ice creams',
    voicepath:'/static/voice/vocabulary/1/ice creams.mp3'
  }, {
    path: '/static/images/ceshiti/juice.png',
    spot: 'juice',
    voicepath:'/static/voice/vocabulary/1/juice.mp3'
  }, {
    path: '/static/images/ceshiti/kite.png',
    spot: 'kite',
    voicepath:'/static/voice/vocabulary/1/kite.mp3'
  }, {
    path: '/static/images/ceshiti/leaves.png',
    spot: 'leaves',
    voicepath:'/static/voice/vocabulary/1/leaves.mp3'
  }, {
    path: '/static/images/ceshiti/mouse.png',
    spot: 'mouse',
    voicepath:'/static/voice/vocabulary/1/mouse.mp3'
  }, {
    path: '/static/images/ceshiti/nose.png',
    spot: 'nose',
    voicepath:'/static/voice/vocabulary/1/Nose.mp3'
  }, {
    path: '/static/images/ceshiti/orange.png',
    spot: 'orange',
    voicepath:'/static/voice/vocabulary/1/orange juice.mp3'
  }, {
    path: '/static/images/ceshiti/plane.png',
    spot: 'plane',
    voicepath:'/static/voice/vocabulary/1/plane.mp3'
  }, {
    path: '/static/images/ceshiti/quiet.png',
    spot: 'quiet',
    voicepath:'/static/voice/vocabulary/1/quiet.mp3'
  }, {
    path: '/static/images/ceshiti/rabbit.png',
    spot: 'rabbit',
    voicepath:'/static/voice/vocabulary/1/rabbit.mp3'
  }, {
    path: '/static/images/ceshiti/snail.png',
    spot: 'snail',
    voicepath:'/static/voice/vocabulary/1/snail.mp3'
  }, {
    path: '/static/images/ceshiti/toes.png',
    spot: 'toes',
    voicepath:'/static/voice/vocabulary/1/toes.mp3'
  }, {
    path: '/static/images/ceshiti/umbrellas.png',
    spot: 'umbrellas',
    voicepath:'/static/voice/vocabulary/1/umbrellas.mp3'
  }, {
    path: '/static/images/ceshiti/volcano.png',
    spot: 'volcano',
    voicepath:'/static/voice/vocabulary/1/volcano.mp3'
  }, {
    path: '/static/images/ceshiti/watch.png',
    spot: 'watch',
    voicepath:'/static/voice/vocabulary/1/watch.mp3'
  }, {
    path: '/static/images/ceshiti/X-ray.png',
    spot: 'X-ray',
    voicepath:'/static/voice/vocabulary/1/X-ray.mp3'
  }, {
    path: '/static/images/ceshiti/yogurt.png',
    spot: 'yogurt',
    voicepath:'/static/voice/vocabulary/1/yogurt.mp3'
  }, {
    path: '/static/images/ceshiti/zebra.png',
    spot: 'zebra',
    voicepath:'/static/voice/vocabulary/1/zebra.mp3'
  },],

  'lv1':[{
    path:'/static/images/ceshiti/prereading/1.png',
    spot:'pirate',
    voicepath:'/static/voice/vocabulary/2/pirate.mp3'
  },{
    path:'/static/images/ceshiti/prereading/2.png',
    spot:'grapes',
    voicepath:'/static/voice/vocabulary/2/grapes.mp3'
  },{
    path:'/static/images/ceshiti/prereading/3.png',
    spot:'strawberries',
    voicepath:'/static/voice/vocabulary/2/Strawberries.mp3'
  },{
    path:'/static/images/ceshiti/prereading/4.png',
    spot:'hole',
    voicepath:'/static/voice/vocabulary/2/hole.mp3'
  },{
    path:'/static/images/ceshiti/prereading/5.png',
    spot:'nest',
    voicepath:'/static/voice/vocabulary/2/nest.mp3'
  },{
    path:'/static/images/ceshiti/prereading/6.png',
    spot:'piano',
    voicepath:'/static/voice/vocabulary/2/Piano.mp3'
  },{
    path:'/static/images/ceshiti/prereading/7.png',
    spot:'drum',
    voicepath:'/static/voice/vocabulary/2/drum.mp3'
  },{
    path:'/static/images/ceshiti/prereading/8.png',
    spot:'bath',
    voicepath:'/static/voice/vocabulary/2/Bath.mp3'
  },{
    path:'/static/images/ceshiti/prereading/9.png',
    spot:'socks',
    voicepath:'/static/voice/vocabulary/2/socks.mp3'
  },{
    path:'/static/images/ceshiti/prereading/10.png',
    spot:'rooster',
    voicepath:'/static/voice/vocabulary/2/rooster.mp3'
  },{
    path:'/static/images/ceshiti/prereading/11.png',
    spot:'pig',
    voicepath:'/static/voice/vocabulary/2/Pig.mp3'
  },{
    path:'/static/images/ceshiti/prereading/12.png',
    spot:'pull',
    voicepath:'/static/voice/vocabulary/2/pullmp3.mp3'
  },{
    path:'/static/images/ceshiti/prereading/13.png',
    spot:'skip',
    voicepath:'/static/voice/vocabulary/2/skip.mp3'
  },{
    path:'/static/images/ceshiti/prereading/14.png',
    spot:'vegetables',
    voicepath:'/static/voice/vocabulary/2/Vegetables.mp3'
  },{
    path:'/static/images/ceshiti/prereading/15.png',
    spot:'seeds',
    voicepath:'/static/voice/vocabulary/2/seeds.mp3'
  },{
    path:'/static/images/ceshiti/prereading/16.png',
    spot:'flower',
    voicepath:'/static/voice/vocabulary/2/flower.mp3'
  },{
    path:'/static/images/ceshiti/prereading/17.png',
    spot:'octopus',
    voicepath:'/static/voice/vocabulary/2/Octopus.mp3'
  },{
    path:'/static/images/ceshiti/prereading/18.png',
    spot:'dolphin',
    voicepath:'/static/voice/vocabulary/2/dolphin.mp3'
  },{
    path:'/static/images/ceshiti/prereading/19.png',
    spot:'tiger',
    voicepath:'/static/voice/vocabulary/2/tiger.mp3'
  },{
    path:'/static/images/ceshiti/prereading/20.png',
    spot:'fish',
    voicepath:'/static/voice/vocabulary/2/fish.mp3'
  },{
    path:'/static/images/ceshiti/prereading/21.png',
    spot:'plane',
    voicepath:'/static/voice/vocabulary/2/plane.mp3'
  },{
    path:'/static/images/ceshiti/prereading/22.png',
    spot:'train',
    voicepath:'/static/voice/vocabulary/2/train.mp3'
  },{
    path:'/static/images/ceshiti/prereading/23.png',
    spot:'bird',
    voicepath:'/static/voice/vocabulary/2/Bird.mp3'
  },{
    path:'/static/images/ceshiti/prereading/24.png',
    spot:'kitten',
    voicepath:'/static/voice/vocabulary/2/Kitten.mp3'
  },],

  'lv2':[{
    path:'/static/images/ceshiti/emergent/1.png',
    spot:'bird',
  },{
    path:'/static/images/ceshiti/emergent/2.png',
    spot:'bat',
  },{
    path:'/static/images/ceshiti/emergent/3.png',
    spot:'kites',
  },{
    path:'/static/images/ceshiti/emergent/4.png',
    spot:'yo-yo',
  },{
    path:'/static/images/ceshiti/emergent/5.png',
    spot:'boat',
  },{
    path:'/static/images/ceshiti/emergent/6.png',
    spot:'horse',
  },{
    path:'/static/images/ceshiti/emergent/7.png',
    spot:'tree',
  },{
    path:'/static/images/ceshiti/emergent/8.png',
    spot:'ladder',
  },{
    path:'/static/images/ceshiti/emergent/9.png',
    spot:'butter',
  },{
    path:'/static/images/ceshiti/emergent/10.png',
    spot:'milk',
  },{
    path:'/static/images/ceshiti/emergent/11.png',
    spot:'windmill',
  },{
    path:'/static/images/ceshiti/emergent/12.png',
    spot:'fan',
  },{
    path:'/static/images/ceshiti/emergent/13.png',
    spot:'motorbike',
  },{
    path:'/static/images/ceshiti/emergent/14.png',
    spot:'rocket',
  },{
    path:'/static/images/ceshiti/emergent/15.png',
    spot:'sea',
  },{
    path:'/static/images/ceshiti/emergent/16.png',
    spot:'space',
  },{
    path:'/static/images/ceshiti/emergent/17.png',
    spot:'2 tigers',
  },{
    path:'/static/images/ceshiti/emergent/18.png',
    spot:'4 monkeys',
  },{
    path:'/static/images/ceshiti/emergent/19.png',
    spot:'honey',
  },{
    path:'/static/images/ceshiti/emergent/20.png',
    spot:'spider web',
  },{
    path:'/static/images/ceshiti/emergent/21.png',
    spot:'giraffe',
  },{
    path:'/static/images/ceshiti/emergent/22.png',
    spot:'snail',
  },{
    path:'/static/images/ceshiti/emergent/23.png',
    spot:'clown',
  },{
    path:'/static/images/ceshiti/emergent/24.png',
    spot:'dance',
  },],

  'lv3':[{
    path:'/static/images/ceshiti/early1/1.png',
    spot:'frog',
  },{
    path:'/static/images/ceshiti/early1/2.png',
    spot:'turtle',
  },{
    path:'/static/images/ceshiti/early1/3.png',
    spot:'shape of a ship',
  },{
    path:'/static/images/ceshiti/early1/4.png',
    spot:'shape of a shirt',
  },{
    path:'/static/images/ceshiti/early1/5.png',
    spot:'birds goup',
  },{
    path:'/static/images/ceshiti/early1/6.png',
    spot:'balloons go up',
  },{
    path:'/static/images/ceshiti/early1/7.png',
    spot:'yell',
  },{
    path:'/static/images/ceshiti/early1/8.png',
    spot:'dig',
  },{
    path:'/static/images/ceshiti/early1/9.png',
    spot:'honey',
  },{
    path:'/static/images/ceshiti/early1/10.png',
    spot:'juice',
  },{
    path:'/static/images/ceshiti/early1/11.png',
    spot:'blanket',
  },{
    path:'/static/images/ceshiti/early1/12.png',
    spot:'umbrella',
  },{
    path:'/static/images/ceshiti/early1/13.png',
    spot:'bees',
  },{
    path:'/static/images/ceshiti/early1/14.png',
    spot:'butterflies',
  },{
    path:'/static/images/ceshiti/early1/15.png',
    spot:'happy face',
  },{
    path:'/static/images/ceshiti/early1/16.png',
    spot:'sad face',
  },{
    path:'/static/images/ceshiti/early1/17.png',
    spot:'my ears',
  },{
    path:'/static/images/ceshiti/early1/18.png',
    spot:'my nose',
  },{
    path:'/static/images/ceshiti/early1/19.png',
    spot:'socks',
  },{
    path:'/static/images/ceshiti/early1/20.png',
    spot:'goggles',
  },{
    path:'/static/images/ceshiti/early1/21.png',
    spot:'bone',
  },{
    path:'/static/images/ceshiti/early1/22.png',
    spot:'sticks',
  },{
    path:'/static/images/ceshiti/early1/23.png',
    spot:'waving',
  },{
    path:'/static/images/ceshiti/early1/24.png',
    spot:'drawing',
  },],

  'lv4': [{
    path: '/static/images/ceshiti/early2/1.png',
    spot: 'a forest fire the forest was on fire'
  }, {
    path: '/static/images/ceshiti/early2/2.png',
    spot: 'a forest fire the snails came out'
  }, {
    path: '/static/images/ceshiti/early2/3.png',
    spot: 'carry me on her back'
  }, {
    path: '/static/images/ceshiti/early2/4.png',
    spot: 'carry me in her mouth'
  }, {
    path: '/static/images/ceshiti/early2/5.png',
    spot: 'charlie’s boat the lake'
  }, {
    path: '/static/images/ceshiti/early2/6.png',
    spot: 'charlie’s boat  a little river'
  }, {
    path: '/static/images/ceshiti/early2/7.png',
    spot: 'hatching eggs baby birds'
  }, {
    path: '/static/images/ceshiti/early2/8.png',
    spot: 'hatching eggs baby snakes'
  }, {
    path: '/static/images/ceshiti/early2/9.png',
    spot: 'helping the zookeeper some hungry seals'
  }, {
    path: '/static/images/ceshiti/early2/10.png',
    spot: 'helping the zookeeper some hungry elephants'
  }, {
    path: '/static/images/ceshiti/early2/11.png',
    spot: 'how do you move see me slide'
  }, {
    path: '/static/images/ceshiti/early2/12.png',
    spot: 'how do you move see me hop'
  }, {
    path: '/static/images/ceshiti/early2/13.png',
    spot: 'I can’t whistle the wind'
  }, {
    path: '/static/images/ceshiti/early2/14.png',
    spot: 'I can’t whistle the coach'
  }, {
    path: '/static/images/ceshiti/early2/15.png',
    spot: 'mixing paint blue and yellow'
  }, {
    path: '/static/images/ceshiti/early2/16.png',
    spot: 'mixing paint yellow and red'
  }, {
    path: '/static/images/ceshiti/early2/17.png',
    spot: 'no bridge swim over'
  }, {
    path: '/static/images/ceshiti/early2/18.png',
    spot: 'no bridge fly over'
  }, {
    path: '/static/images/ceshiti/early2/19.png',
    spot: 'pockets some money'
  }, {
    path: '/static/images/ceshiti/early2/20.png',
    spot: 'pockets some lollipops'
  }, {
    path: '/static/images/ceshiti/early2/21.png',
    spot: 'rainbow balloons two pink balloons'
  }, {
    path: '/static/images/ceshiti/early2/22.png',
    spot: 'rainbow balloons four red balloons'
  }, {
    path: '/static/images/ceshiti/early2/23.png',
    spot: 'we forgot got cold'
  }, {
    path: '/static/images/ceshiti/early2/24.png',
    spot: 'we forgot got hot'
  }],


  'lv5':[{
    path:'/static/images/ceshiti/early3/1.png',
    spot:'Brave Grace coming out of its cave',
  },{
    path:'/static/images/ceshiti/early3/2.png',
    spot:'Brave Grace coming out of the grass',
  },{
    path:'/static/images/ceshiti/early3/3.png',
    spot:'Buddy Likes to Ride Tom went to the beach',
  },{
    path:'/static/images/ceshiti/early3/4.png',
    spot:'Buddy Likes to Ride Tom went to the farm',
  },{
    path:'/static/images/ceshiti/early3/5.png',
    spot:'Careful Counting mother duck',
  },{
    path:'/static/images/ceshiti/early3/6.png',
    spot:'Careful Counting six ducklings',
  },{
    path:'/static/images/ceshiti/early3/7.png',
    spot:'Dirty Animals The birds got dirty',
  },{
    path:'/static/images/ceshiti/early3/8.png',
    spot:'Dirty Animals The cats got dirty',
  },{
    path:'/static/images/ceshiti/early3/9.png',
    spot:'Don’t Smile Sam was grumpy',
  },{
    path:'/static/images/ceshiti/early3/10.png',
    spot:'Don’t Smile Kate made a funny face',
  },{
    path:'/static/images/ceshiti/early3/11.png',
    spot:'Fast And Noisy A big bus went past',
  },{
    path:'/static/images/ceshiti/early3/12.png',
    spot:'Fast And Noisy A big boat sailed past',
  },{
    path:'/static/images/ceshiti/early3/13.png',
    spot:'Feed The Ducks Beth saw two birds',
  },{
    path:'/static/images/ceshiti/early3/14.png',
    spot:'Feed The Ducks Beth saw four rabbits',
  },{
    path:'/static/images/ceshiti/early3/15.png',
    spot:'Go Left or Right jump six times',
  },{
    path:'/static/images/ceshiti/early3/16.png',
    spot:'Go Left or Right skip four times',
  },{
    path:'/static/images/ceshiti/early3/17.png',
    spot:'Lots Of Legs I can swim',
  },{
    path:'/static/images/ceshiti/early3/18.png',
    spot:'Lots Of Legs I can slide',
  },{
    path:'/static/images/ceshiti/early3/19.png',
    spot:'Our Family Band guitar',
  },{
    path:'/static/images/ceshiti/early3/20.png',
    spot:'Our Family Band trumpet',
  },{
    path:'/static/images/ceshiti/early3/21.png',
    spot:'Our Tree House Sometimes it’s a circus',
  },{
    path:'/static/images/ceshiti/early3/22.png',
    spot:'Our Tree House Sometimes it’s a ship',
  },{
    path:'/static/images/ceshiti/early3/23.png',
    spot:'Time For a Swim have a swim in the pond',
  },{
    path:'/static/images/ceshiti/early3/24.png',
    spot:'Time For a Swim have a swim in the pool',
  },],

  'lv6':[{
    path:'/static/images/ceshiti/early4/1.png',
    spot:'All by Myself sail my boat',
  },{
    path:'/static/images/ceshiti/early4/2.png',
    spot:'All by Myself catch a fish',
  },{
    path:'/static/images/ceshiti/early4/3.png',
    spot:'Baby elephant’s trunk got a big knot',
  },{
    path:'/static/images/ceshiti/early4/4.png',
    spot:'Baby elephant’s trunk I’m getting very dirty',
  },{
    path:'/static/images/ceshiti/early4/5.png',
    spot:'lost at the zoo new blue fairy dress',
  },{
    path:'/static/images/ceshiti/early4/6.png',
    spot:'lost at the zoo she ran to see the snakes',
  },{
    path:'/static/images/ceshiti/early4/7.png',
    spot:'shadow on the wall it’s a bird with big wings',
  },{
    path:'/static/images/ceshiti/early4/8.png',
    spot:'shadow on the wall it’s an elephant with tusks',
  },{
    path:'/static/images/ceshiti/early4/9.png',
    spot:'shark and crab don’t eat me',
  },{
    path:'/static/images/ceshiti/early4/10.png',
    spot:'shark and crab he couldn’t swim out',
  },{
    path:'/static/images/ceshiti/early4/11.png',
    spot:'dinner with fox stork was so hungry',
  },{
    path:'/static/images/ceshiti/early4/12.png',
    spot:'dinner with fox fox was not happy',
  },{
    path:'/static/images/ceshiti/early4/13.png',
    spot:'bear got stuck look for food',
  },{
    path:'/static/images/ceshiti/early4/14.png',
    spot:'bear got stuck got the jar off',
  },{
    path:'/static/images/ceshiti/early4/15.png',
    spot:'out in the snow snow is soft and beautiful',
  },{
    path:'/static/images/ceshiti/early4/16.png',
    spot:'out in the snow polar bears live in the snow and ice',
  },{
    path:'/static/images/ceshiti/early4/17.png',
    spot:'living underground moles live in holes',
  },{
    path:'/static/images/ceshiti/early4/18.png',
    spot:'living underground bears live in caves',
  },{
    path:'/static/images/ceshiti/early4/19.png',
    spot:'bugs and beetles wasps have yellow and black stripes',
  },{
    path:'/static/images/ceshiti/early4/20.png',
    spot:'bugs and beetles ladybugs are red bugs with black spots',
  },{
    path:'/static/images/ceshiti/early4/21.png',
    spot:'the moon the moon goes around the earth',
  },{
    path:'/static/images/ceshiti/early4/22.png',
    spot:'the moon the moo is made of rocks and dust',
  },{
    path:'/static/images/ceshiti/early4/23.png',
    spot:'put on your seat belt in a car',
  },{
    path:'/static/images/ceshiti/early4/24.png',
    spot:'be careful on bikes',
  },],
}



// WEBPACK FOOTER //
// ./src/testdata/vocabulary.js